import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

export let startCompetencies = (coursenum, competencies) => {
  const root = createRoot(document.getElementById('competencies_table_container'))
  root.render(<App coursenum={coursenum} competencies={competencies} />)
}
